<template>
    <div class="filter-wrapper-preview" @click="onRemoved">
        <span class="material-icons mainIcon" v-if="type === 'period'"> date_range </span>
        <span class="material-icons mainIcon" v-else-if="type === 'story'"> smart_toy </span>
        <span class="material-icons mainIcon" v-else-if="type === 'query'"> format_quote </span>
        <span class="material-icons mainIcon" v-else-if="type === 'ignore'"> visibility_off </span>
        <span class="material-icons closeIcon"> close </span>
        <span text-truncate="" text-actions="">
            <span text-weight="semi-bold"></span>
            <span>{{ label }}</span>
        </span>
    </div>
</template>

<script>
export default {
    name: "MiniFilterPreview",
    props: {
        type: {
            type: String, //period,story,query,ignored
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        onRemoved: {
            type: Function,
            required: true,
        },
    },
};
</script>

<style scoped></style>
